<div class="modal-header">
    <h4 class="modal-title">{{ titulo }}</h4>
</div>
<div class="modal-body">
      <iframe class="embed-responsive-item" [src]="url | safeUrl" width="100%"    allow="autoplay"  style="min-height: 700px;" frameborder="0"></iframe>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">{{ btnText }}</button>
</div>
